import { type FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { type UiHStackProps } from '@/lib/ui';
import AttendeeCategoryPageForm from './AttendeeCategoryPageForm';
import PageRow from './PageRow';

export interface ManageLabelsProps extends UiHStackProps {
}

const AttendeeCategoryPage: FC<ManageLabelsProps> = ({ ...props }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <PageRow
        title={'Attendee group page'}
        description={'Manage labels and descriptions on the page where we ask the attendee to choose the attendee group, provide the email address, discount code, agree with the privacy policy and T&C.'}
        onEdit={onToggle}
        {...props}
      />
      <AttendeeCategoryPageForm
        onSaveSuccess={() => {}}
        isVisible={isOpen}
        onClose={onToggle}
      />
    </>
  );
};

export default AttendeeCategoryPage;
